import { render, staticRenderFns } from "./NewsItem.vue?vue&type=template&id=29dc8d4d&scoped=true"
import script from "./NewsItem.vue?vue&type=script&lang=js"
export * from "./NewsItem.vue?vue&type=script&lang=js"
import style0 from "./NewsItem.vue?vue&type=style&index=0&id=29dc8d4d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29dc8d4d",
  null
  
)

export default component.exports